import React from 'react';
import {useParams} from 'react-router-dom';

import AppInfo from '@/page/admin/AppsPage/AppInfo';
import AppContent from '@/page/component/AppLayout/AppContent';
import useTitle from '@/hook/useTitle';

export default function AppSettingsPage() {
    useTitle('应用设置');

    const {appId} = useParams();

    return (
        <AppContent>
            <AppInfo appId={appId} roleEditable editable deletable={false} />
        </AppContent>
    );
}
